export const de = {
  hero: {
    title: "Handeln Sie <span>Intelligenter</span> mit Phemex + METRADE",
    subtitle: "Professionelle Handelsstrategien jetzt für alle zugänglich",
    startTrading: "Kostenlos Registrieren",
    signUpForFree: "Kostenlos Registrieren",
    learnMore: "Mehr über Phemex",
    poweredBy: "Unterstützt von",
    socialProof: "Schließen Sie sich über 40.000 Tradern an"
  },
  promo: {
    signUp: "Melden Sie sich heute an und erhalten Sie",
    months: "3 MONATE KOSTENLOS",
    worth: "Wert von 3x29$ • Sparen Sie 87$",
    limitedTime: "Zeitlich begrenztes Angebot! Endet bald"
  },
  whyMetrade: {
    title: "Warum METRADE wählen",
    subtitle: "Der perfekte Partner für Ihre Phemex-Handelsreise",
    reason1: {
      title: "Verifizierte Strategien",
      description: "Alle Premium-Strategien haben nachweisbare Erfolge und werden sorgfältig geprüft"
    },
    reason2: {
      title: "Risikomanagement",
      description: "Fortschrittliche Risikokontrolle in jeder Premium-Strategie zum Schutz Ihres Kapitals"
    },
    reason3: {
      title: "Schweizer Qualität",
      description: "In der Schweiz entwickelt mit Präzision, Zuverlässigkeit und Sicherheit"
    },
    reason4: {
      title: "Nahtlose Integration",
      description: "Folgen Sie der Strategie in Ihrem Phemex-Konto ohne technische Kenntnisse"
    },
    reason5: {
      title: "Vollständige Transparenz",
      description: "Greifen Sie auf Echtzeit-Performancedaten und vollständige Handelshistorie zu"
    },
    reason6: {
      title: "Expertenunterstützung",
      description: "Engagiertes Team von Profis, die Ihnen helfen bereit sind"
    }
  },
  steps: {
    title: "Starten Sie Ihre Handelsreise",
    subtitle: "Beginnen Sie in drei einfachen Schritten",
    step1: {
      title: "Kostenlos registrieren",
      description: "Erstellen Sie Ihr Konto in Sekunden mit Ihrer E-Mail"
    },
    step2: {
      title: "Strategie auswählen",
      description: "Durchsuchen Sie Strategien, die speziell für Phemex-Trader entwickelt wurden"
    },
    step3: {
      title: "Verbinden und Starten",
      description: "Wählen Sie Ihre Strategie mit unserer geführten Einrichtung und beginnen Sie zu traden"
    },
    joinText: "Schließen Sie sich Tausenden erfolgreicher Benutzer auf METRADE an"
  },
  stats: {
    title: "Bewiesene Leistung",
    subtitle: "Unsere Plattform liefert konsistente Ergebnisse für Trader weltweit",
    activeUsers: "Aktive Benutzer in über 90 Ländern",
    tradingVolume: "Täglich verarbeitetes Handelsvolumen",
    successRate: "Zufriedenheitsrate aus Umfragen",
    support: "Prioritärer Support in mehreren Sprachen"
  },
  features: {
    title: "METRADE Marketplace",
    subtitle: "Schließen Sie sich Tausenden erfolgreicher Benutzer an, die ihre Handelserfahrung transformiert haben",
    feature1: {
      title: "Bewährte Strategien",
      description: "Zugang zu erprobten Handelsstrategien mit bestätigten Erfolgsraten bis zu 92%"
    },
    feature2: {
      title: "Risikomanagement",
      description: "Voreingestellte Risikoparameter schützen Ihr Kapital bei Marktvolatilität"
    },
    feature3: {
      title: "Strategie auswählen",
      description: "Wählen Sie Ihre Strategie auf Phemex und folgen Sie in 2 Klicks"
    }
  },
  strategyShowcase: {
    title: "Top-performende Strategien",
    subtitle: "Entdecken Sie unsere erfolgreichsten Handelsstrategien auf Phemex",
    viewAll: "Alle Strategien anzeigen",
    strategy1: {
      name: "Momentum Meister",
      description: "Erfasst Markttrends mit präzisen Ein- und Ausgangspunkten",
      roi: "+175% ROI in 2023",
      winRate: "76% Gewinnrate",
      riskLevel: "Mittleres Risiko"
    },
    strategy2: {
      name: "Volatilitäts-Vorteil",
      description: "Gedeiht in volatilen Märkten mit adaptiven Handelsparametern",
      roi: "+205% ROI in 2023",
      winRate: "81% Gewinnrate",
      riskLevel: "Mittel-Hohes Risiko"
    },
    strategy3: {
      name: "Stetiges Wachstum",
      description: "Konservativer Ansatz mit Fokus auf konsistente Renditen",
      roi: "+90% ROI in 2023",
      winRate: "89% Gewinnrate",
      riskLevel: "Niedriges Risiko"
    },
    phemexCompatible: "Optimiert für Phemex"
  },
  testimonials: {
    title: "Erfolgsgeschichten",
    subtitle: "Hören Sie von Tradern, die bereits von unseren Strategien profitieren",
    testimonial1: {
      quote: "Der Handel mit METRADE über Phemex hat meinen Ansatz vollständig verändert. Die automatisierten Strategien übertreffen meine manuellen Trades deutlich.",
      author: "Thomas R.",
      location: "Deutschland",
      strategy: ""
    },
    testimonial2: {
      quote: "Die Transparenz der METRADE-Plattform in Kombination mit der leistungsstarken Phemex-Schnittstelle gibt mir vollständiges Vertrauen. Ich kann genau sehen, wie meine Investitionen in Echtzeit performen.",
      author: "Sophia L.",
      location: "Singapur",
      strategy: ""
    },
    testimonial3: {
      quote: "Als Neuling im Krypto-Trading hat die Kombination aus Phemex und METRADE die Unsicherheit beseitigt. Ich verdiene jetzt konsistent, ohne Stunden mit der Chartanalyse zu verbringen.",
      author: "David K.",
      location: "Kanada",
      strategy: ""
    }
  },
  faq: {
    title: "Häufig gestellte Fragen",
    subtitle: "Finden Sie Antworten auf häufige Fragen zur METRADE und Phemex-Integration",
    question1: {
      question: "Wie funktioniert die Phemex-METRADE-Integration?",
      answer: "Unsere Plattform verbindet sich mit Ihrem Phemex-Konto über einen sicheren Link mit Handelsberechtigungen. Sobald verbunden, werden die von Ihnen ausgewählten Strategien automatisch Trades basierend auf vordefinierten Parametern ausführen. Sie benötigen ein Phemex-Konto, um eine Strategie zu folgen."
    },
    question2: {
      question: "Welches Mindestkapital ist erforderlich, um zu beginnen?",
      answer: "Minimum 1800 USDT für eine kostenlose Strategie. Minimum 2300 USDT für eine Premium-Strategie mit Risikomanagement."
    },
    question3: {
      question: "Wie kann ich mein Risiko überwachen und kontrollieren?",
      answer: "Jede Premium-Strategie verfügt über integrierte Risikomanagement-Einstellungen, die Sie vor der Aktivierung überprüfen können. Sie können maximale Drawdown-Limits festlegen, und unsere Plattform stoppt den Handel automatisch, wenn diese Limits erreicht werden."
    },
    question5: {
      question: "Was passiert, wenn ich eine Strategie nicht mehr nutzen möchte?",
      answer: "Sie können eine Strategie jederzeit mit einem Klick pausieren oder trennen. Dies stoppt sofort neue Trades und gibt Ihnen Optionen zum Managen offener Positionen."
    },
    question6: {
      question: "Gibt es versteckte Gebühren?",
      answer: "Nein. Wir erheben eine transparente monatliche Abonnementgebühr basierend auf Ihrem gewählten Plan. Es gibt keine zusätzlichen Provisionen auf Gewinne oder versteckte Gebühren. Sie zahlen nur die Standard-Phemex-Handelsgebühren."
    }
  },
  footer: {
    copyright: "Alle Rechte vorbehalten."
  },
  languageSelector: {
    language: "Sprache"
  },
  cta: {
    title: "Bereit, Ihren Handel zu transformieren?",
    subtitle: "Starten Sie heute mit einer 3-monatigen kostenlosen Testversion",
    buttonText: "Kostenlos Registrieren",
    noCredit: "Keine Kreditkarte für die kostenlose Testversion erforderlich"
  }
};
